import Schools from "./schools";

const schoolsPageRoutes = [
    { path: "escolas", element: <Schools /> },
    { path: "schools", element: <Schools /> }
];

export default schoolsPageRoutes;
